import { errorTextStyles as e, formHelperTextStyles as t, formLabelStyles as n, formRootStyles as r } from "../shared/form-primitives.js";
import { cva as i } from "class-variance-authority";
// src/design/forms/input-text/style.ts
var a = r, o = n, s = i([
	"flex w-full rounded-md border border-input-border bg-input-background",
	"text-sm text-foreground placeholder:text-sm placeholder:text-muted-foreground/70",
	"hover:bg-muted",
	"focus-visible:outline-hidden focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
	"disabled:cursor-not-allowed disabled:opacity-90 disabled:bg-muted"
], {
	variants: {
		size: {
			sm: "h-8 px-2.5 py-1.5 text-sm",
			md: "h-10 px-3 py-2",
			lg: "h-12 px-4 py-3 text-base"
		},
		variant: {
			default: "",
			filled: "bg-muted border-transparent focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:border-ring",
			ghost: "border-transparent hover:bg-muted focus-visible:bg-back focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:border-ring"
		},
		invalid: {
			true: "border-destructive focus-visible:border-destructive focus-visible:ring-3 focus-visible:ring-destructive/50",
			false: ""
		}
	},
	defaultVariants: {
		size: "sm",
		variant: "default",
		invalid: !1
	}
}), c = i([
	"flex w-full rounded-md border border-input-border bg-input-background",
	"text-sm text-foreground placeholder:text-sm placeholder:text-muted-foreground/70",
	"transition-colors duration-normal resize-y",
	"focus-visible:outline-hidden focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
	"hover:bg-muted",
	"disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted"
], {
	variants: {
		size: {
			sm: "min-h-[60px] px-2.5 py-1.5 text-xs",
			md: "min-h-[80px] px-3 py-2",
			lg: "min-h-[100px] px-4 py-3 text-base"
		},
		invalid: {
			true: "border-destructive focus-visible:border-destructive",
			false: ""
		}
	},
	defaultVariants: {
		size: "sm",
		invalid: !1
	}
}), l = t, u = e, d = i("text-destructive ml-0.5");
i([
	"flex rounded-md border border-input-border bg-input-background",
	"transition-colors duration-normal",
	"hover:bg-muted",
	"focus-within:outline-hidden focus-within:border-ring focus-within:ring-3 focus-within:ring-ring/50"
], {
	variants: { size: {
		sm: "h-8",
		md: "h-10",
		lg: "h-12"
	} },
	defaultVariants: { size: "sm" }
});
var f = (e) => ({
	root: (e) => a(e),
	label: (e) => o(e),
	input: (t) => s({
		size: e?.size,
		variant: e?.variant,
		invalid: t
	}),
	textarea: (t) => c({
		size: e?.size,
		invalid: t
	}),
	helperText: () => l(),
	errorText: () => u(),
	requiredIndicator: () => d()
});
export { u as errorTextStyles, f as getStyles, l as helperTextStyles, s as inputStyles, o as labelStyles, d as requiredIndicatorStyles, a as rootStyles, c as textareaStyles };

//# sourceMappingURL=style.js.map